import { render, staticRenderFns } from "./OwnerCondominiumObjectOverview.vue?vue&type=template&id=634d946c&scoped=true"
import script from "./OwnerCondominiumObjectOverview.vue?vue&type=script&lang=js"
export * from "./OwnerCondominiumObjectOverview.vue?vue&type=script&lang=js"
import style0 from "./OwnerCondominiumObjectOverview.vue?vue&type=style&index=0&id=634d946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d946c",
  null
  
)

export default component.exports